function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M12.6813 64.1947C24.4916 64.1947 34.0658 54.6205 34.0658 42.8102C34.0658 30.9999 24.4916 21.4258 12.6813 21.4258C0.871016 21.4258 -8.70312 30.9999 -8.70312 42.8102C-8.70312 54.6205 0.871016 64.1947 12.6813 64.1947Z",
  fill: "url(#paint01_linear)"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M23.8023 39.8337C23.8023 36.1884 21.0422 33.4009 17.8575 33.4009C15.6283 33.4009 13.8236 34.1514 12.7089 35.8132C11.5943 34.1514 9.78964 33.4009 7.9319 33.4009C4.32257 33.4009 1.5625 36.1884 1.5625 39.8337C1.5625 39.6729 1.5625 39.7265 1.5625 39.8337C1.5625 39.7801 1.5625 39.8337 1.5625 39.8337C1.5625 45.248 6.7111 50.7159 12.7089 53.0746C17.3798 51.52 23.8023 45.248 23.8023 39.8337C23.8023 39.8337 23.8023 39.7801 23.8023 39.8337C23.8023 39.7265 23.8023 39.6729 23.8023 39.8337Z",
  fill: "url(#paint11_linear)"
});

var _ref4 =
/*#__PURE__*/
React.createElement("rect", {
  x: -11.2031,
  y: 18.9258,
  width: 47.7689,
  height: 47.7689,
  rx: 23.8844,
  stroke: "white",
  strokeWidth: 5
});

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#clip10)"
}, React.createElement("circle", {
  cx: 13.3057,
  cy: 124.323,
  r: 31.3057,
  fill: "#FC4C02"
}), React.createElement("path", {
  opacity: 0.6,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.252 127.454L20.035 145.063L29.4267 127.454H23.5569L20.035 134.106L16.1218 127.454H10.252Z",
  fill: "white"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.4266 102.8L23.5575 127.454H-1.0957L11.4266 102.8ZM11.4266 117.671L16.1224 127.454H6.3394L11.4266 117.671Z",
  fill: "white"
}));

var _ref6 =
/*#__PURE__*/
React.createElement("rect", {
  x: -20.5,
  y: 90.5171,
  width: 67.6114,
  height: 67.6114,
  rx: 33.8057,
  stroke: "white",
  strokeWidth: 5
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M240.318 56.1364C245.025 56.1364 248.84 52.3206 248.84 47.6136C248.84 42.9066 245.025 39.0908 240.318 39.0908C235.611 39.0908 231.795 42.9066 231.795 47.6136C231.795 52.3206 235.611 56.1364 240.318 56.1364Z",
  fill: "url(#paint2_linear1)"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M244.36 50.1029C244.12 50.1008 243.883 50.132 243.645 50.1571C243.599 50.1612 243.547 50.1737 243.526 50.1237C243.501 50.0674 243.549 50.0341 243.589 50.007C243.885 49.8111 244.216 49.7339 244.564 49.7152C244.804 49.7006 245.042 49.711 245.275 49.7819C245.382 49.8131 245.434 49.8757 245.432 49.9841C245.419 50.5635 245.225 51.0679 244.806 51.4785C244.792 51.4931 244.775 51.5056 244.758 51.5181C244.721 51.5452 244.675 51.5702 244.635 51.5369C244.598 51.5056 244.619 51.4598 244.635 51.4223C244.758 51.1159 244.883 50.8115 244.944 50.4843C244.952 50.4426 244.954 50.4009 244.956 50.3613C244.958 50.2258 244.91 50.1675 244.777 50.1341C244.637 50.0966 244.498 50.1029 244.36 50.1029Z",
  fill: "#F6A61F"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M242.74 46.605C242.74 46.9531 242.753 47.2991 242.736 47.6472C242.719 48.0432 242.84 48.3829 243.09 48.6831C243.12 48.7185 243.147 48.7539 243.172 48.7915C243.261 48.9269 243.245 49.0207 243.122 49.125C242.859 49.3459 242.599 49.5689 242.336 49.7899C242.18 49.9212 242.082 49.9191 241.923 49.7899C241.711 49.6169 241.544 49.4043 241.396 49.1771C241.36 49.1229 241.342 49.125 241.298 49.1666C241.035 49.423 240.758 49.6606 240.406 49.7794C239.862 49.9649 239.309 49.9941 238.763 49.8003C238.238 49.6127 237.923 49.225 237.807 48.6852C237.677 48.0828 237.744 47.5096 238.115 46.9989C238.396 46.6133 238.786 46.3861 239.234 46.2465C239.697 46.1047 240.174 46.0505 240.654 46.0026C240.789 45.988 240.923 45.9755 241.058 45.963C241.092 45.9609 241.121 45.9567 241.119 45.913C241.114 45.692 241.137 45.4669 241.085 45.2502C241.019 44.9729 240.837 44.8104 240.56 44.7499C240.362 44.7061 240.166 44.7186 239.974 44.7833C239.683 44.8833 239.501 45.0855 239.428 45.3856C239.389 45.5503 239.311 45.6087 239.151 45.592C238.809 45.5566 238.467 45.5211 238.128 45.4857C237.988 45.4711 237.915 45.3648 237.944 45.2293C238.121 44.3643 238.688 43.8786 239.505 43.6556C240.133 43.4847 240.768 43.4743 241.398 43.6515C241.904 43.7932 242.33 44.0433 242.567 44.5394C242.703 44.8208 242.734 45.1251 242.738 45.4294C242.742 45.8192 242.738 46.2131 242.74 46.605C242.738 46.605 242.74 46.605 242.74 46.605ZM241.119 47.2553C241.119 47.1511 241.114 47.0469 241.121 46.9426C241.125 46.878 241.102 46.8551 241.037 46.8614C240.879 46.8759 240.718 46.878 240.56 46.8989C240.283 46.9343 240.012 47.0031 239.787 47.1782C239.459 47.4345 239.391 47.7847 239.445 48.1787C239.509 48.6414 239.922 48.8978 240.364 48.7435C240.664 48.6393 240.848 48.4184 240.975 48.1411C241.108 47.8598 241.119 47.5575 241.119 47.2553Z",
  fill: "#050606"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M240.347 51.9601C238.756 51.9497 237.329 51.5412 236.038 50.6803C235.776 50.5052 235.526 50.3135 235.288 50.103C235.267 50.0842 235.246 50.0654 235.23 50.0425C235.207 50.0112 235.19 49.9737 235.217 49.9362C235.244 49.8945 235.29 49.8903 235.33 49.9091C235.421 49.9529 235.509 50.0008 235.599 50.0467C236.42 50.4802 237.285 50.7929 238.191 50.9909C239.013 51.1701 239.842 51.2535 240.684 51.2306C241.887 51.1972 243.046 50.9554 244.161 50.5073C244.215 50.4844 244.272 50.4615 244.328 50.449C244.407 50.4344 244.486 50.4448 244.522 50.5302C244.555 50.6094 244.511 50.672 244.453 50.722C244.411 50.7574 244.363 50.7866 244.315 50.8179C243.596 51.2848 242.808 51.5849 241.975 51.7704C241.424 51.8955 240.866 51.9559 240.347 51.9601Z",
  fill: "#F6A61F"
});

var _ref11 =
/*#__PURE__*/
React.createElement("rect", {
  x: 229.295,
  y: 36.5908,
  width: 22.0456,
  height: 22.0456,
  rx: 11.0228,
  stroke: "white",
  strokeWidth: 5
});

var _ref12 =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#clip11)"
}, React.createElement("circle", {
  cx: 120.381,
  cy: 82.9468,
  r: 15.6528,
  fill: "#F3BA2F"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M113.122 85.2934L115.257 83.1592L113.122 81.025L110.988 83.1592L113.122 85.2934Z",
  fill: "white"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M128.062 85.2934L130.196 83.1592L128.062 81.025L125.928 83.1592L128.062 85.2934Z",
  fill: "white"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M120.593 85.2934L122.727 83.1592L120.593 81.025L118.459 83.1592L120.593 85.2934Z",
  fill: "white"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M121.659 74.6223L120.592 73.5552L114.723 79.4243L116.857 81.5585L120.592 77.8237L124.327 81.5585L126.461 79.4243L121.659 74.6223Z",
  fill: "white"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M119.525 91.696L120.592 92.7631L126.461 86.894L124.327 84.7598L120.592 88.4947L116.857 84.7598L114.723 86.894L119.525 91.696Z",
  fill: "white"
}));

var _ref13 =
/*#__PURE__*/
React.createElement("rect", {
  x: 102.229,
  y: 64.7939,
  width: 36.3057,
  height: 36.3057,
  rx: 18.1528,
  stroke: "white",
  strokeWidth: 5
});

var _ref14 =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#clip22)"
}, React.createElement("circle", {
  cx: 65.2153,
  cy: 78.2979,
  r: 15.6528,
  fill: "#2C78EF"
}), React.createElement("path", {
  d: "M71.6853 77.1836C71.6853 77.1836 73.2308 77.2616 73.2308 76.3536C73.2308 75.1659 71.1726 74.0958 71.1726 74.0958C71.1726 74.0958 71.4955 73.4126 71.696 73.0304C71.898 72.6483 72.4642 71.1579 72.5147 70.8185C72.5789 70.3905 72.481 70.256 72.481 70.256C72.3418 71.1732 70.8467 73.8131 70.7288 73.9032C69.2705 73.22 67.2674 73.0304 67.2674 73.0304C67.2674 73.0304 65.3071 68.9062 63.4631 68.9062C61.6344 68.9062 61.6436 72.4373 61.6436 72.4373C61.6436 72.4373 61.1263 71.4361 60.479 71.4361C59.5303 71.4361 59.2196 72.8699 59.2196 74.423C57.3466 74.423 55.7719 74.8403 55.6311 74.88C55.4903 74.9213 55.0481 75.2423 55.2486 75.2025C55.6587 75.0711 57.5822 74.773 59.2655 74.9198C59.3589 76.3964 60.222 78.3194 60.222 78.3194C60.222 78.3194 58.3718 80.9959 58.3718 82.9082C58.3718 83.4111 58.5907 84.3313 59.919 84.3313C61.0315 84.3313 62.2802 83.6633 62.5158 83.5273C62.3108 83.8208 62.1593 84.3772 62.1593 84.634C62.1593 84.8434 62.2832 85.438 63.1417 85.438C64.2435 85.438 65.4739 84.5943 65.4739 84.5943C65.4739 84.5943 66.6354 86.5233 67.63 87.4084C67.8978 87.6469 68.1534 87.6897 68.1534 87.6897C68.1534 87.6897 67.1664 86.7404 65.8656 84.2947C67.0745 83.5487 68.3324 81.7893 68.3324 81.7893C68.3324 81.7893 68.4809 81.7939 69.6286 81.7939C71.4267 81.7939 73.9807 81.4163 73.9807 79.9886C73.9807 78.515 71.6853 77.1836 71.6853 77.1836ZM71.8857 76.297C71.8857 76.8183 71.3899 76.8106 71.3899 76.8106L71.0119 76.8366C71.0119 76.8366 70.2958 76.4606 69.8627 76.2848C69.8627 76.2848 70.5345 75.2484 70.6921 74.9595C70.8115 75.0283 71.8857 75.7009 71.8857 76.297ZM64.3629 70.9836C65.2076 70.9836 66.4135 72.9769 66.4135 72.9769C66.4135 72.9769 64.5312 72.8088 62.9826 73.7183C63.0239 72.2829 63.5075 70.9836 64.3629 70.9836ZM61.0131 72.5993C61.2824 72.5993 61.5456 72.9249 61.6543 73.2016C61.6543 73.385 61.7492 74.452 61.7492 74.452L60.1975 74.3939C60.1975 72.9953 60.7453 72.5993 61.0131 72.5993ZM60.854 82.3075C60.0062 82.3075 59.8302 81.8351 59.8302 81.4102C59.8302 80.4487 60.5984 79.1035 60.5984 79.1035C60.5984 79.1035 61.46 80.9134 62.9642 81.6777C62.2174 82.1149 61.6023 82.3075 60.854 82.3075ZM63.6069 84.2029C63.0117 84.2029 62.9397 83.8177 62.9397 83.7291C62.9397 83.4524 63.1555 83.1253 63.1555 83.1253C63.1555 83.1253 64.1548 82.4512 64.219 82.3793L64.9566 83.7551C64.9566 83.7551 64.2007 84.2029 63.6069 84.2029ZM65.4616 83.4524C65.099 82.8196 64.8327 82.1592 64.8327 82.1592C64.8327 82.1592 66.3186 82.2555 67.1174 81.4316C66.62 81.6548 65.8258 81.9376 64.9031 81.8519C66.8328 80.1537 67.959 78.9232 68.9109 77.6498C68.8298 77.552 68.3936 77.2478 68.2865 77.1974C67.7127 77.8883 65.4769 80.276 63.408 81.4576C60.7866 80.0299 60.2373 75.8293 60.1806 74.9564L61.613 75.094C61.613 75.094 61.0743 76.0463 61.0743 76.748C61.0743 77.4481 61.1585 77.4863 61.1585 77.4863C61.1585 77.4863 61.1401 76.2634 61.8961 75.3202C62.4715 78.3805 63.0713 79.9488 63.5396 80.8828C63.7768 80.785 64.2206 80.5878 64.2206 80.5878C64.2206 80.5878 62.8984 76.7801 62.9719 74.2028C63.5717 73.8834 64.4593 73.5532 65.4616 73.5532C68.0983 73.5532 70.2177 74.6874 70.2177 74.6874L69.3883 75.8446C69.3883 75.8446 68.6492 74.507 67.6055 74.2686C68.1564 74.6798 68.7731 75.2209 69.093 76.0005C66.9077 75.1475 64.2711 74.6966 63.4248 74.5972C63.3514 74.9091 63.3606 75.3554 63.3606 75.3554C63.3606 75.3554 66.897 76.0066 69.471 77.4786C69.4526 80.6948 65.9452 83.165 65.4616 83.4524ZM68.8114 81.0479C68.8114 81.0479 69.9086 79.608 69.8918 77.7018C69.8918 77.7018 71.6654 78.7993 71.6654 79.8694C71.6654 81.0662 68.8114 81.0479 68.8114 81.0479Z",
  fill: "white"
}));

var _ref15 =
/*#__PURE__*/
React.createElement("rect", {
  x: 47.0625,
  y: 60.145,
  width: 36.3057,
  height: 36.3057,
  rx: 18.1528,
  stroke: "white",
  strokeWidth: 5
});

var _ref16 =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#clip33)"
}, React.createElement("circle", {
  cx: 189.18,
  cy: 78.6059,
  r: 22.4692,
  fill: "#2156E7"
}), React.createElement("path", {
  d: "M197.996 71.283C196.529 69.6972 194.62 68.5883 192.516 68.1C190.412 67.6117 188.21 67.7665 186.195 68.5443C184.179 69.3221 182.444 70.6871 181.214 72.4625C179.983 74.2378 179.314 76.3418 179.293 78.5018C179.273 80.6617 179.901 82.7782 181.097 84.577C182.293 86.3759 184.001 87.7742 186.001 88.5908C188.001 89.4074 190.199 89.6047 192.313 89.1572C194.426 88.7096 196.356 87.6379 197.853 86.0807L194.274 82.6395C193.466 83.4798 192.424 84.0582 191.284 84.2997C190.144 84.5412 188.957 84.4347 187.878 83.9941C186.799 83.5534 185.877 82.7988 185.232 81.8281C184.586 80.8574 184.247 79.7153 184.258 78.5497C184.27 77.3842 184.631 76.2488 185.295 75.2908C185.959 74.3327 186.895 73.5961 187.982 73.1764C189.07 72.7567 190.258 72.6732 191.394 72.9367C192.529 73.2002 193.559 73.7985 194.351 74.6543L197.996 71.283Z",
  fill: "white"
}));

var _ref17 =
/*#__PURE__*/
React.createElement("rect", {
  x: 164.211,
  y: 53.6367,
  width: 49.9383,
  height: 49.9383,
  rx: 24.9692,
  stroke: "white",
  strokeWidth: 5
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  d: "M264.493 105.728C273.138 105.728 280.146 98.7196 280.146 90.0747C280.146 81.4299 273.138 74.4219 264.493 74.4219C255.848 74.4219 248.84 81.4299 248.84 90.0747C248.84 98.7196 255.848 105.728 264.493 105.728Z",
  fill: "#454545"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  d: "M257.536 86.8002C256.735 86.8002 255.946 86.8002 255.119 86.8002C255.226 85.8673 255.507 85.022 255.958 84.2394C257.079 82.2984 258.701 80.9648 260.879 80.37C264.373 79.412 268.042 80.9836 269.776 84.1642C269.92 84.421 270.052 84.6839 270.171 84.9532C270.277 85.1848 270.183 85.3413 269.927 85.3413C269.313 85.3476 268.687 85.3852 268.08 85.3226C267.842 85.2975 267.579 85.0658 267.429 84.8592C266.327 83.3503 264.868 82.5113 262.989 82.4925C260.554 82.4612 258.375 84.0641 257.655 86.3995C257.617 86.5184 257.58 86.6562 257.536 86.8002Z",
  fill: "#16A7E7"
});

var _ref20 =
/*#__PURE__*/
React.createElement("path", {
  d: "M255.1 89.0669C255.889 89.0669 256.627 89.0544 257.372 89.0857C257.466 89.092 257.592 89.2986 257.629 89.4363C258.005 90.795 258.838 91.8156 260.015 92.5356C262.269 93.9193 265.293 93.3746 267.021 91.3147C267.146 91.1644 267.265 91.0141 267.371 90.8576C267.578 90.5633 267.854 90.4193 268.223 90.4319C268.724 90.4506 269.225 90.4319 269.726 90.4381C270.145 90.4444 270.233 90.5758 270.064 90.964C268.718 94.0445 265.481 95.9166 262.056 95.6411C258.337 95.3406 255.619 92.4542 255.131 89.3362C255.112 89.2673 255.112 89.2047 255.1 89.0669Z",
  fill: "#16A7E7"
});

var _ref21 =
/*#__PURE__*/
React.createElement("path", {
  d: "M271.668 99.529C271.167 99.529 270.666 99.5353 270.165 99.529C269.771 99.5227 269.633 99.2973 269.827 98.9467C270.328 98.0513 270.835 97.156 271.349 96.2669C271.53 95.9602 271.787 95.9539 271.969 96.2607C272.501 97.1685 273.021 98.0827 273.528 99.0031C273.684 99.2911 273.546 99.5102 273.215 99.5227C272.695 99.5415 272.182 99.529 271.668 99.529Z",
  fill: "#16A7E7"
});

var _ref22 =
/*#__PURE__*/
React.createElement("rect", {
  x: 246.34,
  y: 71.9219,
  width: 36.3057,
  height: 36.3057,
  rx: 18.1528,
  stroke: "white",
  strokeWidth: 5
});

var _ref23 =
/*#__PURE__*/
React.createElement("path", {
  d: "M320.899 101.079C329.544 101.079 336.552 94.0706 336.552 85.4258C336.552 76.781 329.544 69.7729 320.899 69.7729C312.254 69.7729 305.246 76.781 305.246 85.4258C305.246 94.0706 312.254 101.079 320.899 101.079Z",
  fill: "#F5F5F5"
});

var _ref24 =
/*#__PURE__*/
React.createElement("path", {
  d: "M315.918 77.9205C314.584 77.9205 313.305 78.4626 312.362 79.4275C311.419 80.3924 310.889 81.701 310.889 83.0655C310.89 84.4296 311.42 85.7374 312.364 86.7015L312.361 86.7041L313.784 88.1592L320.898 95.4346L328.012 88.1586L325.878 85.9759L323.744 88.1586L320.898 91.069L318.053 88.1586L315.919 90.3412L313.785 88.1582L315.919 85.9753L314.497 84.5202L314.497 84.5195C314.12 84.134 313.907 83.6108 313.907 83.0651C313.907 82.7948 313.959 82.5272 314.06 82.2774C314.161 82.0277 314.309 81.8008 314.496 81.6097C314.683 81.4185 314.905 81.2669 315.149 81.1635C315.393 81.06 315.655 81.0068 315.919 81.0068C316.452 81.0072 316.964 81.2244 317.341 81.6107L317.342 81.61L318.764 83.0651L320.898 80.8821L319.476 79.4271L319.473 79.4297C318.531 78.4645 317.252 77.9216 315.918 77.9204L315.918 77.9205Z",
  fill: "#E8463D"
});

var _ref25 =
/*#__PURE__*/
React.createElement("path", {
  d: "M325.878 77.9199C324.544 77.921 323.266 78.4638 322.323 79.4289L322.321 79.4262L320.898 80.8817L318.764 83.0653L320.898 85.2482L324.455 81.6102L324.456 81.6109C324.833 81.2248 325.344 81.0077 325.878 81.0073C326.142 81.0072 326.404 81.0604 326.648 81.1638C326.892 81.2672 327.114 81.4188 327.301 81.6099C327.487 81.801 327.636 82.0279 327.737 82.2776C327.838 82.5274 327.89 82.795 327.89 83.0653C327.889 83.611 327.677 84.1341 327.299 84.5197L327.3 84.5204L325.877 85.9761L328.011 88.1587L328.012 88.1584L329.435 86.7033L329.432 86.7006C330.376 85.7367 330.907 84.429 330.908 83.065C330.908 81.7005 330.378 80.3919 329.435 79.427C328.491 78.4621 327.212 77.92 325.878 77.92L325.878 77.9199Z",
  fill: "#4788F1"
});

var _ref26 =
/*#__PURE__*/
React.createElement("path", {
  d: "M325.879 85.9761L323.745 88.1583L320.9 91.0688L318.054 88.1583L315.92 90.3413L320.9 95.4344L328.013 88.1587L325.879 85.9761Z",
  fill: "#3BA757"
});

var _ref27 =
/*#__PURE__*/
React.createElement("path", {
  d: "M318.765 83.0659L318.764 83.0663L313.785 88.159L315.919 90.342L318.054 88.159L320.899 85.2489L318.765 83.0659Z",
  fill: "#F8BA2E"
});

var _ref28 =
/*#__PURE__*/
React.createElement("rect", {
  x: 302.746,
  y: 67.2729,
  width: 36.3057,
  height: 36.3057,
  rx: 18.1528,
  stroke: "white",
  strokeWidth: 5
});

var _ref29 =
/*#__PURE__*/
React.createElement("ellipse", {
  cx: 369.867,
  cy: 27.489,
  rx: 22.472,
  ry: 22.489,
  fill: "white"
});

var _ref30 =
/*#__PURE__*/
React.createElement("path", {
  d: "M369.867 49.9781C382.277 49.9781 392.339 39.9094 392.339 27.489C392.339 15.0687 382.277 5 369.867 5C357.456 5 347.395 15.0687 347.395 27.489C347.395 39.9094 357.456 49.9781 369.867 49.9781Z",
  fill: "#EA4B4B"
});

var _ref31 =
/*#__PURE__*/
React.createElement("path", {
  d: "M382.016 21.3043C382.016 21.1918 382.016 21.0794 381.907 20.967V20.8545C381.582 19.8425 380.714 19.1678 379.629 19.1678H379.846C379.846 19.1678 375.615 18.4932 369.866 18.4932C364.224 18.4932 359.885 19.1678 359.885 19.1678H360.102C359.017 19.1678 358.149 19.8425 357.824 20.8545V20.967C357.824 21.0794 357.824 21.1918 357.715 21.3043C357.607 22.4287 357.281 24.7901 357.281 27.4888C357.281 30.1875 357.607 32.5488 357.715 33.6733C357.715 33.7857 357.715 33.8982 357.824 34.0106V34.1231C358.149 35.1351 359.017 35.8097 360.102 35.8097H359.885C359.885 35.8097 364.116 36.4844 369.866 36.4844C375.507 36.4844 379.846 35.8097 379.846 35.8097H379.629C380.714 35.8097 381.582 35.1351 381.907 34.1231V34.0106C381.907 33.8982 381.907 33.7857 382.016 33.6733C382.124 32.5488 382.45 30.1875 382.45 27.4888C382.45 24.7901 382.233 22.4287 382.016 21.3043ZM373.554 28.051L368.455 31.8741C368.347 31.9866 368.238 31.9866 368.13 31.9866C368.021 31.9866 367.913 31.9866 367.804 31.8741C367.587 31.7617 367.479 31.5368 367.479 31.3119V23.6656C367.479 23.4408 367.587 23.2159 367.804 23.1034C368.021 22.991 368.238 22.991 368.455 23.1034L373.554 26.9266C373.663 27.039 373.771 27.2639 373.771 27.4888C373.88 27.7137 373.771 27.9386 373.554 28.051Z",
  fill: "white"
});

var _ref32 =
/*#__PURE__*/
React.createElement("rect", {
  x: 344.895,
  y: 2.5,
  width: 49.9383,
  height: 49.9383,
  rx: 24.9692,
  stroke: "white",
  strokeWidth: 5
});

var _ref33 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M358.458 91.1684C360.394 97.619 366.382 102.319 373.47 102.319C382.124 102.319 389.14 95.3107 389.14 86.666C389.14 78.0212 382.124 71.0132 373.47 71.0132C365.166 71.0132 358.371 77.4663 357.834 85.6261C358.848 87.3271 359.244 88.3791 358.458 91.1684H358.458Z",
  fill: "url(#paint3_linear1)"
});

var _ref34 =
/*#__PURE__*/
React.createElement("path", {
  d: "M372.723 83.2681C372.723 83.294 372.723 83.32 372.724 83.3443L368.878 88.8199C368.255 88.7922 367.629 88.8993 367.037 89.1386C366.775 89.243 366.53 89.3713 366.301 89.5194L357.855 86.112C357.855 86.112 357.659 89.2629 358.474 91.6112L364.444 94.0256C364.744 95.3385 365.663 96.4902 367.019 97.0442C369.238 97.9526 371.796 96.9173 372.719 94.7422C372.959 94.1737 373.071 93.5773 373.055 92.9823L378.558 89.128C378.603 89.1293 378.648 89.1307 378.693 89.1307C381.986 89.1307 384.663 86.4994 384.663 83.2681C384.663 80.0366 381.986 77.4077 378.693 77.4077C375.401 77.4077 372.723 80.0366 372.723 83.2681ZM371.8 94.3641C371.086 96.0446 369.115 96.8419 367.402 96.1425C366.612 95.8198 366.015 95.2288 365.671 94.5241L367.614 95.3134C368.878 95.8291 370.327 95.242 370.852 94.0044C371.379 92.7655 370.781 91.3428 369.519 90.8271L367.51 90.0113C368.285 89.723 369.166 89.7124 369.99 90.0483C370.82 90.3868 371.464 91.0241 371.805 91.8386C372.147 92.6531 372.145 93.5522 371.8 94.3641ZM378.693 87.1737C376.5 87.1737 374.715 85.4218 374.715 83.2681C374.715 81.1162 376.5 79.3637 378.693 79.3637C380.887 79.3637 382.672 81.1162 382.672 83.2681C382.672 85.4218 380.887 87.1737 378.693 87.1737ZM375.713 83.2622C375.713 81.642 377.051 80.328 378.7 80.328C380.35 80.328 381.688 81.642 381.688 83.2622C381.688 84.8824 380.35 86.1953 378.7 86.1953C377.051 86.1953 375.713 84.8824 375.713 83.2622Z",
  fill: "#F2F2F2"
});

var _ref35 =
/*#__PURE__*/
React.createElement("rect", {
  x: 355.334,
  y: 68.5132,
  width: 36.3057,
  height: 36.3057,
  rx: 18.1528,
  stroke: "white",
  strokeWidth: 5
});

var _ref36 =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#clip44)"
}, React.createElement("circle", {
  cx: 366.764,
  cy: 145.239,
  r: 22.4692,
  fill: "black"
}), React.createElement("path", {
  d: "M366.794 167.699C354.544 167.879 344.091 157.588 344.298 144.906C344.496 132.935 354.103 122.77 366.785 122.77C379.179 122.77 389.542 132.755 389.218 145.94C388.94 157.741 379.215 167.753 366.794 167.699ZM363.496 134.768C363.496 134.723 359.325 134.966 357.258 135.253C355.712 135.469 354.193 135.856 352.674 136.251C351.758 136.485 351.236 137.509 351.398 138.516C351.506 139.181 352.27 140.17 353.268 140.062C353.762 140.008 354.265 139.927 354.751 139.801C357.618 139.091 360.539 138.804 363.478 138.804C366.021 138.804 368.574 138.965 371.063 139.523C372.87 139.927 374.685 140.376 376.438 140.97C377.759 141.419 378.99 142.129 380.258 142.722C381.183 143.163 382.298 142.812 382.81 141.931C383.448 140.826 382.99 139.612 381.723 138.911C378.685 137.249 375.44 136.197 372.061 135.559C369.23 135.029 366.372 134.759 363.496 134.768ZM363.541 142.488C360.035 142.479 357.123 142.893 354.265 143.693C353.151 144.007 352.603 145.041 353.043 146.039C353.411 146.874 354.283 147.198 355.281 146.892C357.402 146.254 359.586 145.967 361.788 145.859C363.783 145.76 365.76 145.931 367.738 146.227C370.111 146.578 372.402 147.18 374.595 148.142C375.683 148.618 376.707 149.238 377.795 149.724C378.667 150.119 379.826 149.346 379.934 148.393C380.051 147.387 379.449 146.865 378.685 146.434C376.015 144.906 373.148 143.873 370.155 143.234C367.792 142.722 365.41 142.462 363.541 142.488ZM363.352 149.876C363.352 149.84 359.892 149.984 358.184 150.191C357.033 150.326 355.91 150.613 354.778 150.874C354.112 151.027 353.663 151.791 353.816 152.375C354.023 153.121 354.787 153.552 355.515 153.39C356.521 153.166 357.528 152.968 358.543 152.815C360.826 152.474 363.118 152.339 365.419 152.546C366.695 152.663 367.98 152.869 369.23 153.148C371.333 153.615 373.292 154.451 375.144 155.548C375.665 155.853 376.267 155.79 376.654 155.449C377.391 154.802 377.31 153.831 376.429 153.274C374.523 152.078 372.456 151.233 370.281 150.667C368.016 150.065 365.707 149.75 363.352 149.876Z",
  fill: "#1CD760"
}));

var _ref37 =
/*#__PURE__*/
React.createElement("rect", {
  x: 341.795,
  y: 120.27,
  width: 49.9383,
  height: 49.9383,
  rx: 24.9692,
  stroke: "white",
  strokeWidth: 5
});

var _ref38 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "paint01_linear",
  x1: 12.6813,
  y1: 21.4258,
  x2: -7.42006,
  y2: 59.4901,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FCFCFC"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#EBEBEB"
})), React.createElement("linearGradient", {
  id: "paint11_linear",
  x1: 12.6718,
  y1: 33.4145,
  x2: 12.6718,
  y2: 53.1084,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FF61AD"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#FF2719"
})), React.createElement("linearGradient", {
  id: "paint2_linear1",
  x1: 240.318,
  y1: 39.0908,
  x2: 232.306,
  y2: 54.2614,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FCFCFC"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#EBEBEB"
})), React.createElement("linearGradient", {
  id: "paint3_linear1",
  x1: 373.487,
  y1: 71.0132,
  x2: 373.487,
  y2: 102.319,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#111D2E"
}), React.createElement("stop", {
  offset: 0.21248,
  stopColor: "#051839"
}), React.createElement("stop", {
  offset: 0.40695,
  stopColor: "#0A1B48"
}), React.createElement("stop", {
  offset: 0.5811,
  stopColor: "#132E62"
}), React.createElement("stop", {
  offset: 0.7376,
  stopColor: "#144B7E"
}), React.createElement("stop", {
  offset: 0.87279,
  stopColor: "#136497"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#1387B8"
})), React.createElement("clipPath", {
  id: "clip0"
}), React.createElement("clipPath", {
  id: "clip1"
}), React.createElement("clipPath", {
  id: "clip2"
}), React.createElement("clipPath", {
  id: "clip3"
}), React.createElement("clipPath", {
  id: "clip4"
}));

var SvgOnboardingDataSources = function SvgOnboardingDataSources(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 375,
    height: 173,
    viewBox: "0 0 375 190",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgOnboardingDataSources, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/onboardingDataSources.2c249034.svg";
export { ForwardRef as ReactComponent };